// account
export const LOGIN = 'login';
export const LOGIN_OAUTH = 'loginOAuth';
export const SIGNUP = 'signup';
export const SIGNUP_OAUTH = 'signupOAuth';
export const LOGOUT = 'logout';
export const UPDATE_ACCOUNT = 'updateAccount';
export const FORGOT_PASSWORD = 'forgotPassword';
export const RESET_PASSWORD = 'resetPassword';
export const RESET_PASSWORD_AUTHED = 'resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY = 'resetPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY = 'requestSetPasswordAndVerify';
export const GET_AUTH_ACCOUNT = 'getAuthAccount';
export const REQUEST_EMAIL_VERIFICATION = 'requestEmailVerification';
export const VERIFY_EMAIL = 'verifyEmail';
export const CLEAR_ACCOUNT_ISLOADING = 'clearAccountIsLoading';

// organization
export const REGISTER_ORGANIZATION = 'registerOrganization';
export const SIGNUP_ORGANIZATION = 'signupOrganization';
export const GET_ORGANIZATIONS = 'getOrganizations';
export const GET_ORGANIZATION = 'getOrganization';
export const EDIT_ORGANIZATION = 'editOrganization';
export const DELETE_ORGANIZATION = 'deleteOrganization';
export const CLEAR_ORGANIZATION_ISLOADING = 'clearOrganizationIsLoading';

// donation
export const REGISTER_DONATION = 'registerDonation';
export const GET_DONATIONS = 'getDonations';
export const EXPORT_DONATIONS = 'exportDonations';
export const TOGGLE_DONATION_IS_ACTIVE = 'toggleDonationIsActive';
export const MOVE_DONATION_TO_FOLDER = 'moveDonationToFolder';
export const BULK_MOVE_DONATIONS_TO_FOLDER = 'bulkMoveDonationsToFolder';
export const EDIT_DONATION = 'editDonation';
export const DELETE_DONATION = 'deleteDonation';
export const BULK_DELETE_DONATIONS = 'bulkDeleteDonations';
export const CLEAR_DONATION_ISLOADING = 'clearDonationIsLoading';

// folder
export const REGISTER_FOLDER = 'registerFolder';
export const GET_FOLDERS = 'getFolders';
export const EDIT_FOLDER = 'editFolder';
export const DELETE_FOLDER = 'deleteFolder';
export const CLEAR_FOLDER_ISLOADING = 'clearFolderIsLoading';

// announcement
export const REGISTER_ANNOUNCEMENT = 'registerAnnouncement';
export const GET_ANNOUNCEMENTS = 'getAnnouncements';
export const EXPORT_ANNOUNCEMENTS = 'exportAnnouncements';
export const TOGGLE_ANNOUNCEMENT_IS_ACTIVE = 'toggleAnnouncementIsActive';
export const MOVE_ANNOUNCEMENT_TO_FOLDER = 'moveAnnouncementToFolder';
export const BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER = 'bulkMoveAnnouncementsToFolder';
export const EDIT_ANNOUNCEMENT = 'editAnnouncement';
export const DELETE_ANNOUNCEMENT = 'deleteAnnouncement';
export const BULK_DELETE_ANNOUNCEMENTS = 'bulkDeleteAnnouncements';
export const CLEAR_ANNOUNCEMENT_ISLOADING = 'clearAnnouncementIsLoading';

// shiurei torah
export const REGISTER_SHIUREI_TORAH = 'registerShiureiTorah';
export const GET_SHIUREI_TORAHS = 'getShiureiTorahs';
export const EXPORT_SHIUREI_TORAHS = 'exportShiureiTorahs';
export const TOGGLE_SHIUREI_TORAH_IS_ACTIVE = 'toggleShiureiTorahIsActive';
export const MOVE_SHIUREI_TORAH_TO_FOLDER = 'moveShiureiTorahToFolder';
export const BULK_MOVE_SHIUREI_TORAHS_TO_FOLDER = 'bulkMoveShiureiTorahsToFolder';
export const EDIT_SHIUREI_TORAH = 'editShiureiTorah';
export const DELETE_SHIUREI_TORAH = 'deleteShiureiTorah';
export const BULK_DELETE_SHIUREI_TORAHS = 'bulkDeleteShiureiTorahs';
export const CLEAR_SHIUREI_TORAH_ISLOADING = 'clearShiureiTorahIsLoading';

// template
export const REGISTER_TEMPLATE = 'registerTemplate';
export const GET_TEMPLATES = 'getTemplates';
export const EDIT_TEMPLATE = 'editTemplate';
export const DELETE_TEMPLATE = 'deleteTemplate';
export const CLEAR_TEMPLATE_ISLOADING = 'clearTemplateIsLoading';

// shiurei torah template
export const REGISTER_SHIUREI_TORAH_TEMPLATE = 'registerShiureiTorahTemplate';
export const GET_SHIUREI_TORAH_TEMPLATES = 'getShiureiTorahTemplates';
export const EDIT_SHIUREI_TORAH_TEMPLATE = 'editShiureiTorahTemplate';
export const DELETE_SHIUREI_TORAH_TEMPLATE = 'deleteShiureiTorahTemplate';
export const CLEAR_SHIUREI_TORAH_TEMPLATE_ISLOADING = 'clearShiureiTorahTemplateIsLoading';

// screen
export const REGISTER_SCREEN = 'registerScreen';
export const GET_SCREENS = 'getScreens';
export const GET_SCREENS_UNPOPULATED = 'getScreensUnpopulated';
export const GET_SCREEN = 'getScreen';
export const REFRESH_SCREEN = 'refreshScreen';
export const EDIT_SCREEN = 'editScreen';
export const DELETE_SCREEN = 'deleteScreen';
export const CLEAR_SCREEN_ISLOADING = 'clearScreenIsLoading';

// screen_artboard
export const REGISTER_SCREEN_ARTBOARD = 'registerScreenArtboard';
export const GET_SCREEN_ARTBOARDS = 'getScreenArtboards';
export const GET_SCREEN_ARTBOARD = 'getScreenArtboard';
export const GET_SCREEN_ARTBOARD_CONTENT = 'getScreenArtboardContent';
export const EDIT_SCREEN_ARTBOARD = 'editScreenArtboard';
export const DELETE_SCREEN_ARTBOARD = 'deleteScreenArtboard';
export const CLEAR_SCREEN_ARTBOARD_ISLOADING = 'clearScreenArtboardIsLoading';

// member
export const REGISTER_MEMBER = 'registerMember';
export const GET_MEMBERS = 'getMembers';
export const GET_MEMBER = 'getMember';
export const EDIT_MEMBER = 'editMember';
export const DELETE_MEMBER = 'deleteMember';
export const CLEAR_MEMBER_ISLOADING = 'clearMemberIsLoading';

// minyanim
export const REGISTER_MINYANIM = 'registerMinyanim';
export const GET_MINYANIMS = 'getMinyanims';
export const GET_MINYANIM = 'getMinyanim';
export const EDIT_MINYANIM = 'editMinyanim';
export const SYNC_MINYANIM = 'syncMinyanim';
export const DELETE_MINYANIM = 'deleteMinyanim';
export const CLEAR_MINYANIM_ISLOADING = 'clearMinyanimIsLoading';

// minyanim_type
export const REGISTER_MINYANIM_TYPE = 'registerMinyanimType';
export const GET_MINYANIM_TYPES = 'getMinyanimTypes';
export const GET_MINYANIM_TYPE = 'getMinyanimType';
export const EDIT_MINYANIM_TYPE = 'editMinyanimType';
export const DELETE_MINYANIM_TYPE = 'deleteMinyanimType';
export const CLEAR_MINYANIM_TYPE_ISLOADING = 'clearMinyanimTypeIsLoading';

// minyanim_countdown
export const REGISTER_MINYANIM_COUNTDOWN = 'registerMinyanimCountdown';
export const GET_MINYANIM_COUNTDOWNS = 'getMinyanimCountdowns';
export const GET_MINYANIM_COUNTDOWN = 'getMinyanimCountdown';
export const EDIT_MINYANIM_COUNTDOWN = 'editMinyanimCountdown';
export const DELETE_MINYANIM_COUNTDOWN = 'deleteMinyanimCountdown';
export const CLEAR_MINYANIM_COUNTDOWN_ISLOADING = 'clearMinyanimCountdownIsLoading';

// room
export const REGISTER_ROOM = 'registerRoom';
export const GET_ROOMS = 'getRooms';
export const GET_ROOM = 'getRoom';
export const EDIT_ROOM = 'editRoom';
export const DELETE_ROOM = 'deleteRoom';
export const CLEAR_ROOM_ISLOADING = 'clearRoomIsLoading';

// zmanim
export const REGISTER_ZMANIM = 'registerZmanim';
export const GET_ZMANIMS = 'getZmanims';
export const EDIT_ZMANIM = 'editZmanim';
export const DELETE_ZMANIM = 'deleteZmanim';
export const CLEAR_ZMANIM_ISLOADING = 'clearZmanimIsLoading';

// event
export const REGISTER_EVENT = 'registerEvent';
export const GET_EVENTS = 'getEvents';
export const EDIT_EVENT = 'editEvent';
export const DELETE_EVENT = 'deleteEvent';
export const CLEAR_EVENT_ISLOADING = 'clearEventIsLoading';

// ticket
export const ADD_TICKET = 'addTicket'
export const GET_TICKETS = 'getTickets'
export const DELETE_TICKET = 'deleteTicket'
export const EDIT_TICKET = 'editTicket'
export const CLOSE_TICKET = 'closeTicket'
export const CLEAR_TICKETS_ISLOADING = 'clearTicketsIsLoading'
export const GET_TICKET_UNREAD = 'getTicketUnread'
export const MARK_TICKET_READ = 'markTicketRead'
export const UPSERT_TICKET = 'upsertTicket'
export const CLEAR_TICKET_UNREAD = 'clearTicketUnread'
export const ASSIGN_TICKET = 'assignTicket'
export const SET_TICKET_STATUS = 'setTicketStatus'

// ticket
export const ADD_TICKET_COMMENT = 'addTicketComment'
export const GET_TICKET_COMMENTS = 'getTicketComments'
export const DELETE_TICKET_COMMENT = 'deleteTicketComment'
export const EDIT_TICKET_COMMENT = 'editTicketComment'
export const CLEAR_TICKET_COMMENTS = 'clearTicketComments'
export const CLEAR_TICKET_COMMENTS_ISLOADING = 'clearTicketCommentsIsLoading'

// date_time_banner
export const REGISTER_DATE_TIME_BANNER = 'registerDateTimeBanner'
export const GET_DATE_TIME_BANNERS = 'getDateTimeBanners'
export const DELETE_DATE_TIME_BANNER = 'deleteDateTimeBanner'
export const EDIT_DATE_TIME_BANNER = 'editDateTimeBanner'
export const CLEAR_DATE_TIME_BANNERS = 'clearDateTimeBanners'
export const CLEAR_DATE_TIME_BANNER_ISLOADING = 'clearDateTimeBannerIsLoading'

// poster
export const REGISTER_POSTER = 'registerPoster'
export const GET_POSTERS = 'getPosters'
export const DELETE_POSTER = 'deletePoster'
export const EDIT_POSTER = 'editPoster'
export const CLEAR_POSTERS = 'clearPosters'
export const CLEAR_POSTER_ISLOADING = 'clearPosterIsLoading'

// api_token
export const REGISTER_API_KEY = 'registerapiKey'
export const GET_API_KEYS = 'getapiKeys'
export const DELETE_API_KEY = 'deleteapiKey'
export const EDIT_API_KEY = 'editapiKey'
export const CLEAR_API_KEYS = 'clearapiKeys'
export const CLEAR_API_KEY_ISLOADING = 'clearapiKeyIsLoading'

// minyan_roll_N
export const REGISTER_MINYAN_ROLL_N = 'registerMinyanRoll_N'
export const GET_MINYAN_ROLLS_N = 'getMinyanRolls_N'
export const GET_MINYAN_ROLL_N = 'getMinyanRoll_N'
export const EDIT_MINYAN_ROLL_N = 'editMinyanRoll_N'
export const DELETE_MINYAN_ROLL_N = 'deleteMinyanRoll_N'
export const TOGGLE_MINYAN_ROLL_N_IS_ACTIVE = 'toggleMinyanRoll_NIsActive'
export const MOVE_MINYAN_ROLL_N_TO_FOLDER = 'moveMinyanRoll_NToFolder'
export const CLEAR_MINYAN_ROLL_N_ISLOADING = 'clearMinyanRoll_NIsLoading'

// zmanim_N
export const REGISTER_ZMANIM_N = 'registerZmanim_N'
export const GET_ZMANIMS_N = 'getZmanims_N'
export const GET_ZMANIM_N = 'getZmanim_N'
export const EDIT_ZMANIM_N = 'editZmanim_N'
export const DELETE_ZMANIM_N = 'deleteZmanim_N'
export const TOGGLE_ZMANIM_N_IS_ACTIVE = 'toggleZmanim_NIsActive'
export const CLEAR_ZMANIM_N_ISLOADING = 'clearZmanim_NIsLoading'

// zmanim_display_override_N
export const REGISTER_ZMANIM_DISPLAY_OVERRIDE_N = 'registerZmanimDisplayOverride_N'
export const GET_ZMANIM_DISPLAY_OVERRIDES_N = 'getZmanimDisplayOverrides_N'
export const GET_ZMANIM_DISPLAY_OVERRIDE_N = 'getZmanimDisplayOverride_N'
export const EDIT_ZMANIM_DISPLAY_OVERRIDE_N = 'editZmanimDisplayOverride_N'
export const DELETE_ZMANIM_DISPLAY_OVERRIDE_N = 'deleteZmanimDisplayOverride_N'
export const TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE = 'toggleZmanimDisplayOverride_NIsActive'
export const CLEAR_ZMANIM_DISPLAY_OVERRIDE_N_ISLOADING = 'clearZmanimDisplayOverride_NIsLoading'

// minyan_N
export const REGISTER_MINYAN_N = 'registerMinyan_N'
export const GET_MINYANS_N = 'getMinyans_N'
export const GET_MINYAN_N = 'getMinyan_N'
export const EDIT_MINYAN_N = 'editMinyan_N'
export const DELETE_MINYAN_N = 'deleteMinyan_N'
export const CLEAR_MINYAN_N_ISLOADING = 'clearMinyan_NIsLoading'

// custom_font
export const REGISTER_CUSTOM_FONT = 'registerCustomFont'
export const GET_CUSTOM_FONTS = 'getCustomFonts'
export const EDIT_CUSTOM_FONT = 'editCustomFont'
export const DELETE_CUSTOM_FONT = 'deleteCustomFont'
export const CLEAR_CUSTOM_FONT_ISLOADING = 'clearCustomFontIsLoading'

// kabbalah_N
export const GET_KABBALAHS_N = 'getKabbalahs_N';
export const GET_KABBALAH_N = 'getKabbalah_N';
export const GET_KABBALAH_N_STATS = 'getKabbalahStats_N';
export const REGISTER_KABBALAH_N = 'registerKabbalah_N';
export const EDIT_KABBALAH_N = 'editKabbalah_N';
export const APPROVE_KABBALAH_N = 'approveKabbalah_N';
export const REJECT_KABBALAH_N = 'rejectKabbalah_N';
export const MARK_VIEWED_KABBALAH_N = 'markViewedKabbalah_N';
export const TOGGLE_KABBALAH_N_IS_ACTIVE = 'toggleKabbalah_NIsActive';
export const DELETE_KABBALAH_N = 'deleteKabbalah_N';
export const EDIT_KABBALAH_DISPLAY = 'editKabbalahDisplay';
export const CLEAR_KABBALAH_N_ISLOADING = 'clearKabbalah_NIsLoading';

// kabbalah_design_N
export const GET_KABBALAH_DESIGN_N = 'getKabbalahDesign_N';
export const SAVE_KABBALAH_DESIGN_N = 'saveKabbalahDesign_N';
export const CLEAR_KABBALAH_DESIGN_N_ISLOADING = 'clearKabbalahDesign_NIsLoading';

// sidenav
export const UPDATE_SIDENAV = 'updateSidenav';
export const CLEAR_SIDENAV = 'clearSidenav';

// router_loader
export const UPDATE_ROUTER_LOADER = 'updateRouterLoader';
export const CLEAR_ROUTER_LOADER = 'clearRouterLoader';

// error
export const CLEAR_ERRORMSG = 'clearErrorMessage';
export const UPDATE_ERRORMSG = 'updateErrorMessage';

// activity log
export const RECORD_EXPORT = 'recordExport';
